class Typeahead {
  constructor ($parent, $input) {
    this.store = { data: null, current_results: null };
    this.$typeahead = $(`<div class="typeahead"></div>`);
    this.callbacks = {};
    this.$parent = $parent;
    this.$input = $input;
    // this is when you manually trigger an open possibly by a click elsewhere
    // we do not want to automatically close the modal then because of that click.
    this.preventCloseOnce = false;

    var self = this;

    $parent.append(this.$typeahead);

    let fillResult = (value) => {
      $input.text(value);
    };

    $input.on("input", () => {
      const value = $input.text().trim().toLowerCase();
      this.open(value);
    });

    $input.on("keydown", (e) => {
      if (e.keyCode === 40 && this.current_results) {
        e.preventDefault();
        let $elem = this.$typeahead.find(".result").eq(0).focus();
        fillResult($elem.data("value"));
      }
    });

    this.$typeahead.on("keydown", ".result", function (e) {
      if (e.keyCode === 40) {
        let $elem = $(this).next().focus();
        fillResult($elem.data("value"));
      } else if (e.keyCode === 38) {
        if ($(this).prev().is(".result")) {
          let $elem = $(this).prev().focus();
          fillResult($elem.data("value"));
        } else $input.focus();
      } else if (e.keyCode === 13) {
        self.callbacks.submit($(this).data("value"));
      } else {
        return;
      }

      e.preventDefault();
    });

    this.$typeahead.on("click", ".result", function (e) {
      self.callbacks.submit($(this).data("value"));
    });

    $("body").on("click", (e) => {
      if (this.preventCloseOnce) {
        this.preventCloseOnce = false;
        return;
      }

      if (!$(e.target).is(".typeahead") && $(e.target).closest(".typeahead").length === 0) {
        this.close();
      }
    });
  }

  data (data) {
    this.data = data;

    return this;
  }

  on (name, cb) {
    this.callbacks[name] = cb;

    return this;
  }

  close () {
    this.$typeahead.text("");
    this.$parent.removeClass("show");
  }

  open (value) {
    if (!value) {
      value = "";
      this.preventCloseOnce = true;
    }

    this.$typeahead.text("");

    let data = (typeof this.data === "function") ? this.data() : this.data;

    if (value.length === 0) {
      this.current_results = data;
    } else {
      let results = data.filter(o => o.toLowerCase().indexOf(value) > -1);

      let firstResults = results.filter(o => o.toLowerCase().indexOf(value) === 0);
      let lastResults = results.filter(o => o.toLowerCase().indexOf(value) !== 0);

      this.current_results = firstResults.concat(lastResults);
    }

    let html = this.current_results.map(o => {
      return `<div class="result" tabindex="1" data-value="${o}">${o}</div>`;
    }).slice(0, 5).join("");

    this.$typeahead.append($(html));
    this.$parent.addClass("show");
  }
}

export default Typeahead;



// WEBPACK FOOTER //
// ./src/js/typeahead.js